import { CountryCode } from 'libphonenumber-js';
import { countryListWithFlag } from 'utils/validators/HelperComponents';
import strings from '../../../../../common/Translation/Translate';
import { FormModel } from '../../../../../components/Form';
import { Validators } from '../../../../../utils/validators';

export const AddEditOrganizationForm = (currencyLocaleList: any[], defaultCountry: CountryCode): FormModel[] => {
  return [
    {
      label: strings.organization_section1,
      value: '',
      type: 'section',
      placeholder: '',
      field: 'organization_section1',
      autoFocus: true,
      validators: [],
      required: false,
      responsive: { xs: 12, sm: 12 },
    },
    {
      label: strings.organization_text_name,
      value: '',
      type: 'text',
      placeholder: '',
      field: 'name',
      autoFocus: true,
      validators: [{ check: Validators.validateMandatoryField }, { check: Validators.validateString }],
      required: true,
      responsive: { xs: 12, sm: 12, md: 6, lg: 4 },
    },

    {
      label: strings.organization_text_email,
      value: '',
      size: 'medium',
      type: 'text',
      placeholder: strings.organization_text_email,
      field: 'email',
      validators: [
        { check: Validators.validateMandatoryField },
        { check: Validators.validateEmail },
        { check: Validators.validateString },
      ],
      responsive: { xs: 12, sm: 12, md: 6, lg: 4 },
      required: true,
    },
    {
      label: strings.parentOrg_text_location,
      value: '',
      size: 'medium',
      type: 'select',
      placeholder: strings.parentOrg_text_location,
      field: 'location',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 12, sm: 12, md: 6, lg: 4 },
      required: true,
      isMulti: false,
    },
    {
      label: strings.organization_text_phone,
      value: {},
      size: 'medium',
      type: 'phoneInput',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: strings.organization_text_phone,
      field: 'phone',
      validators: [{ check: Validators.validateMandatoryField }, { check: Validators.validateMobile }],
      responsive: { xs: 12, sm: 12, md: 6, lg: 4 },
      required: true,
      defaultCountry: defaultCountry,
    },
    {
      label: strings.organization_text_contact_name,
      value: '',
      type: 'text',
      placeholder: '',
      field: 'contactName',
      validators: [{ check: Validators.validateString }],
      required: false,
      responsive: { xs: 12, sm: 12, md: 6, lg: 4 },
    },
    {
      label: strings.updateProfile_text_designation,
      value: '',
      type: 'text',
      placeholder: '',
      field: 'designation',
      validators: [{ check: Validators.validateString }],
      required: false,
      responsive: { xs: 12, sm: 12, md: 6, lg: 4 },
    },
    {
      label: strings.organization_text_gst,
      value: '',
      type: 'text',
      placeholder: '',
      field: 'gstNumber',
      validators: [{ check: Validators.validateMandatoryField }, { check: Validators.validateString, max: 20 }],
      required: true,
      responsive: { xs: 12, sm: 12, md: 6, lg: 4 },
    },
    {
      label: strings.organization_text_pinCode,
      value: '',
      type: 'text',
      placeholder: '',
      field: 'pinCode',
      validators: [{ check: Validators.validateMandatoryField }, { check: Validators.validatePinCode }],
      required: true,
      responsive: { xs: 12, sm: 12, md: 6, lg: 4 },
    },
    {
      label: strings.organization_text_orderPrefix,
      value: 'ORD',
      type: 'text',
      placeholder: strings.organization_text_orderPrefix_placeholder,
      field: 'orderPrefix',
      validators: [{ check: Validators.validateMandatoryField }, { check: Validators.validateOrderPrefix }],
      required: true,
      responsive: { xs: 12, sm: 12, md: 6, lg: 4 },
    },
    {
      label: strings.organization_section2,
      value: '',
      type: 'section',
      placeholder: '',
      field: 'organization_section2',
      autoFocus: true,
      validators: [],
      required: false,
      responsive: { xs: 12, sm: 12 },
    },
    {
      label: strings.organization_text_latitude,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'number',
      variant: 'outlined',
      placeholder: '',
      field: 'latitude',
      validators: [{ check: Validators.validateString }],
      responsive: { xs: 12, sm: 12, md: 6, lg: 3 },
      required: false,
    },
    {
      label: strings.organization_text_longitude,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'number',
      variant: 'outlined',
      placeholder: '',
      field: 'longitude',
      validators: [{ check: Validators.validateString }],
      responsive: { xs: 12, sm: 12, md: 6, lg: 3 },
      required: false,
    },
    {
      label: strings.organization_text_placeId,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'placeId',
      validators: [{ check: Validators.validateString }],
      responsive: { xs: 12, sm: 12, md: 6, lg: 3 },
      required: false,
    },
    {
      label: strings.organization_text_streetViewExp,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'streetViewUrl',
      validators: [{ check: Validators.validateString }],
      responsive: { xs: 12, sm: 12, md: 6, lg: 3 },
      required: false,
    },
    {
      label: strings.organization_section3,
      value: '',
      type: 'section',
      placeholder: '',
      field: 'organization_section3',
      autoFocus: true,
      validators: [],
      required: false,
      responsive: { xs: 12, sm: 12 },
    },
    {
      label: strings.organization_text_serviceChargePercent,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'number',
      variant: 'outlined',
      placeholder: '',
      field: 'serviceChargePercentage',
      validators: [{ check: Validators.validateMandatoryField }, { check: Validators.validateInt, max: 100 }],
      responsive: { xs: 12, sm: 12, md: 6, lg: 3 },
      required: true,
    },
    {
      label: strings.organization_section4,
      value: '',
      type: 'section',
      placeholder: '',
      field: 'organization_section4',
      autoFocus: true,
      validators: [],
      required: false,
      responsive: { xs: 12, sm: 12 },
    },
    {
      label: strings.organization_text_roomsAvailable,
      value: '',
      size: 'medium',
      type: 'select',
      placeholder: strings.organization_text_roomsAvailable,
      field: 'roomsAvailable',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 12, sm: 12, md: 6, lg: 4 },
      required: true,
      isMulti: false,
    },
    {
      label: strings.organization_text_holdDays,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'number',
      variant: 'outlined',
      placeholder: '',
      field: 'holdDays',
      validators: [
        { check: Validators.validateMandatoryField },
        { check: Validators.validateInt, message: strings.invalidHoldDaysMsg, max: 1800 },
      ],
      responsive: { xs: 12, sm: 12, md: 6, lg: 4 },
      required: true,
    },

    {
      label: strings.organization_text_confirmationBy,
      value: '',
      size: 'medium',
      type: 'select',
      placeholder: strings.organization_text_confirmationBy,
      field: 'bookingConfirmationBy',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 12, sm: 12, md: 6, lg: 4 },
      required: true,
      isMulti: false,
    },
    {
      label: strings.organization_text_show_alternate_days,
      value: '',
      size: 'medium',
      type: 'select',
      placeholder: strings.organization_text_show_alternate_days,
      field: 'showAlternativeDates',
      validators: [],
      responsive: { xs: 12, sm: 12, md: 6, lg: 4 },
      required: false,
      isMulti: false,
    },
    {
      label: strings.organization_text_alternativeDateInterval,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'number',
      variant: 'outlined',
      placeholder: '',
      field: 'alternativeDateInterval',
      validators: [{ check: Validators.validateInt, max: 100 }],
      responsive: { xs: 12, sm: 12, md: 6, lg: 4 },
      required: false,
    },
    {
      label: strings.organization_showRFQForExceedingBookingWindowTimeFrame,
      value: '',
      size: 'medium',
      type: 'select',
      placeholder: strings.organization_showRFQForExceedingBookingWindowTimeFrame,
      field: 'showRFQForExceedingBookingWindowTimeFrame',
      validators: [],
      responsive: { xs: 12, sm: 12 },
      required: false,
      isMulti: false,
    },
    {
      label: strings.organization_show_booking_window_time_frame,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'number',
      variant: 'outlined',
      placeholder: '',
      field: 'bookingWindowTimeFrame',
      validators: [{ check: Validators.validateInt, max: 300 }],
      responsive: { xs: 12, sm: 12 },
      required: false,
    },
    {
      label: strings.organization_text_address,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'address',
      multiline: true,
      validators: [{ check: Validators.validateMandatoryField }, { check: Validators.validateString }],
      responsive: { xs: 12, sm: 12 },
      required: true,
    },
    {
      label: strings.organization_section6,
      value: '',
      type: 'section',
      placeholder: '',
      field: 'organization_section6',
      autoFocus: true,
      validators: [],
      required: false,
      responsive: { xs: 12, sm: 12 },
    },
    {
      label: strings.organization_text_currency_locale,
      value: '',
      size: 'medium',
      type: 'drop-down',
      placeholder: '',
      field: 'currencyLocale',
      validators: [{ check: Validators.validateMandatoryField }, { check: Validators.validateString, min: 5, max: 5 }],
      required: true,
      responsive: { xs: 12, md: 6 },
      options: currencyLocaleList,
    },
    {
      label: strings.organization_text_default_country_code,
      value: '',
      size: 'medium',
      type: 'drop-down',
      placeholder: '',
      field: 'defaultCountryCode',
      validators: [{ check: Validators.validateMandatoryField }, { check: Validators.validateString, min: 2, max: 5 }],
      required: true,
      responsive: { xs: 12, md: 6 },
      options: countryListWithFlag,
    },
  ];
};
